import PredictionsPoster from "./predictionsPoster/PredictionsPoster";
import PredictionImage from "./predictionImage/PredictionImage";
import PredictionImageCorrect from "./predictionImageCorrect/PredictionImageCorrect";

export const MODAL_TYPES = {
  PredictionsPoster: "PredictionsPoster",
  PredictionImage: "PredictionImage",
  PredictionImageCorrect: "PredictionImageCorrect",
};

export const MODALS = {
  PredictionsPoster: PredictionsPoster,
  PredictionImage: PredictionImage,
  PredictionImageCorrect: PredictionImageCorrect,
};
